import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import { B3, B4, SH3 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import { LoggedInNavigation } from '@zet/utils/interface'
import moment from 'moment'

import ReopenLead from './reopenLead'

type LeadExpiredProps = {
  item?: object
  brandName?: string
  inactive?: boolean
}

const LeadExpired = ({ item, brandName, inactive }: LeadExpiredProps) => {
  const { navigate } = useNavigation<LoggedInNavigation>()
  const status = item?.status
  const customerId = item?.customerId
  const partnerId = item?.partnerId
  const { data: user } = useUserContext()

  if (status == LeadStatus.EXPIRED) {
    return (
      <Stack className="border-grays-40 bg-neutral-white100 mt-2 rounded-sm border-l-4">
        <XStack className=" pt-4/2 px-3">
          <Stack className="bg-error-20 absolute left-[30] h-4 w-1" />
          <Stack className="bg-error-20 absolute left-3 top-3 items-center rounded-lg">
            <Icon
              type={'CautionOutlined'}
              size={20}
              color={zetColors.error[100]}
              className="m-1.5"
            />
          </Stack>
          <Stack className="left-6 justify-center">
            <SH3 className="  text-grays-80">{i18n.t('leads.leadExpired')}</SH3>
            <B4 className=" text-grays-50">
              {i18n.t('leads.expireOn', {
                date: moment.utc(item?.lastUpdatedDate).format('DD-MMM-YYYY'),
              })}
            </B4>
          </Stack>
        </XStack>

        {item?.rejectionReason ? (
          <Stack className="mb-4/2 bg-error-20 mx-3 mt-2 rounded">
            <B3 className="px-4/2 text-grays-60  py-2">
              {item?.rejectionReason}
            </B3>
          </Stack>
        ) : (
          <></>
        )}

        <ReopenLead
          reopen={item?.isReopenAllowed}
          reopenDays={item?.reopenDays}
          reopenDate={item?.reopenDate}
          shareNewLink={item?.isShareNewLink}
          inactive={inactive}
          leadId={item?.id}
          leadStatus={status}
          userId={user?.id}
          customerId={customerId}
          customerName={item?.name}
          customerPhoneNumber={item?.phoneNumber}
          partnerId={partnerId}
          brandName={brandName}
        />
      </Stack>
    )
  }
}

export default LeadExpired
